import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export function AiMarkdownRenderer({ content }: { content: string }) {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        table: ({ children }) => (
          <div className="overflow-x-auto my-3">
            <table className="w-full text-left border-collapse text-sm">{children}</table>
          </div>
        ),
        th: ({ children }) => (
          <th className="bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 font-semibold px-3 py-2 border border-gray-200 dark:border-gray-600">
            {children}
          </th>
        ),
        td: ({ children }) => (
          <td className="px-3 py-2 border-b border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-300">
            {children}
          </td>
        ),
        h1: ({ children }) => (
          <h1 className="text-lg font-bold text-gray-800 dark:text-gray-100 mt-4 mb-2">{children}</h1>
        ),
        h2: ({ children }) => (
          <h2 className="text-base font-bold text-gray-800 dark:text-gray-100 mt-3 mb-1">{children}</h2>
        ),
        h3: ({ children }) => (
          <h3 className="text-sm font-bold text-gray-700 dark:text-gray-200 mt-2 mb-1">{children}</h3>
        ),
        ul: ({ children }) => (
          <ul className="list-disc ml-5 my-2 space-y-1 text-gray-700 dark:text-gray-300">{children}</ul>
        ),
        ol: ({ children }) => (
          <ol className="list-decimal ml-5 my-2 space-y-1 text-gray-700 dark:text-gray-300">{children}</ol>
        ),
        li: ({ children }) => <li className="text-sm leading-relaxed">{children}</li>,
        strong: ({ children }) => (
          <strong className="font-bold text-gray-900 dark:text-white">{children}</strong>
        ),
        em: ({ children }) => <em className="italic">{children}</em>,
        code: ({ children }) => (
          <code className="bg-gray-100 dark:bg-gray-700 text-primary-700 dark:text-primary-300 rounded px-1 py-0.5 text-xs font-mono">
            {children}
          </code>
        ),
        p: ({ children }) => (
          <p className="mb-3 text-sm text-gray-700 dark:text-gray-300 leading-relaxed last:mb-0">
            {children}
          </p>
        ),
      }}
    >
      {content}
    </ReactMarkdown>
  );
}
